import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of constructors based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('constructors', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single constructor based on his ID
 *
 * @param id the of the constructor requested
 */
export function getFromId(id) {
  return baseGetFromId('constructors', id);
}

/**
 * Get a single constructor based on his ID
 *
 * @param id the of the constructor requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('constructors', id, 'identification');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single constructor based on his ID
 *
 * @param id the of the constructor requested
 * @param data the new data of the constructor
 */
export function editFromId(id, data) {
  return baseEditFromId('constructors', id, data);
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new constructor
 *
 * @param data the new data of the partner
 */
export function newItem(data) {
  return baseNewItem('constructors', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all constructors to serve in a dropdown form choice
 */
export function fetchConstructors() {
  return baseIndex('constructors', 1, 0);
}
